export default __webpack_public_path__ + "static/media/moon.67a48526.png";